<template>

  <svg
    t="1628693945974"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4043"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="64"
    height="64"
  ><path d="M754.72592555 754.72592555a243.06574222 243.06574222 0 0 0-194.18073998-237.77431666L560.54518557 414.90963001l97.09036998 0 0-97.09037113-97.09036998 0 0-97.09036999 145.63555555 0 0-97.09036999-145.63555554 0-1e-8-97.09037113-97.09037114 0L463.45481443 516.95160889A243.06574222 243.06574222 0 0 0 269.27407445 754.72592555c0 133.83907554 108.88684999 242.72592555 242.72592555 242.72592668s242.72592555-108.88684999 242.72592555-242.72592668z m-388.3614811 0c0-80.29373667 65.34181888-145.63555555 145.63555555-145.63555554s145.63555555 65.34181888 145.63555555 145.63555554-65.34181888 145.63555555-145.63555555 145.63555555-145.63555555-65.34181888-145.63555555-145.63555555z" p-id="4044" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconKey',
} as DefineComponent
</script>